import React, {Component} from 'react';
import './App.css';

import {
  Switch,
  Redirect,
  Route,
  BrowserRouter,
  withRouter,
  HashRouter,
} from 'react-router-dom';


import Index from './pages/Index/index';
import Home from './pages/Home/home';

import Art from './pages/Product/Art/art';
import Temp from './pages/Journey/Temp/temp';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentWillMount() {

  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  shouldComponentUpdate() {

  }

  render() {
    return (
        <HashRouter>
          <Switch>
            {/*<Redirect from="/" to="/index" exact />*/}
            <Route path="/" component={Home}></Route>
            {/*<Route path="/index" component={Index}></Route>*/}
            {/*<Redirect from="/product" to="/product/art" exact />*/}
            {/*<Route path="/product/art" component={Art}/>*/}
            {/*<Redirect from="/journey" to="/journey/temp" exact />*/}
            {/*<Route path="/journey/temp" component={Temp}/>*/}
            {/*<Route path="/home" component={Home}/>*/}
            <Redirect path="*" to='/'></Redirect>
          </Switch>
        </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js
